
import cookies from 'js-cookie';
import { getQueryParams } from '@/utils/query';
import { webCountry } from './locale';

type KpnType = 'KWAI' | 'KWAI_BULLDOG' | 'KWAI.ME';

// 端内取cookie, 端外取query
export const kpn = cookies.get('kpn') as KpnType || getQueryParams().kpn;

export const isKwai = kpn === 'KWAI';
export const isSnack = kpn === 'KWAI_BULLDOG';
export const isKwaiMe = kpn === 'KWAI.ME';
export const isInApp = ['KWAI', 'KWAI_BULLDOG', 'KWAI.ME'].includes(cookies.get('kpn') || '');
export const isYodaEnv = /yoda/i.test(navigator.userAgent);
export const isStrictInApp = isInApp && isYodaEnv;
export const NOT_LOGIN_RES_CODE = [109, 6002];
// ISLP/1 低端机  ISLP/0 高端机
export const isLowPhone = /ISLP\/1/.test(navigator.userAgent);

const device = {
    isIOS (ua: string) {
        return !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
    },
    isAndroid (ua: string) {
        return ua.includes('Android') || ua.includes('Adr');
    },
    isLogin (ua: string) {
        const token = cookies.get('token');
        const ud = cookies.get('ud');
        return (
        // eslint-disable-next-line no-mixed-operators
            device.isIOS(ua) && !!token ||
      (device.isAndroid(ua) && (ud !== '0' && !!ud))
        );
    },
    isInApp () {
        const KPN: string = cookies.get('kpn') || '';
        return ['KWAI', 'KWAI_BULLDOG', 'KWAI.ME'].includes(KPN);
    },

};

export const deviceInfo = () => {
    const ua = navigator.userAgent;

    const isIphone14Device = () => {
        try {
            const screenWidth = window.screen.width;
            const screenHeight = window.screen.height;

            return device.isIOS(ua) && window.devicePixelRatio === 3 &&
              (
                  (screenWidth === 393 && screenHeight === 852) // 14p
                || (screenWidth === 430 && screenHeight === 932) // 14p max
              ); // 14p max

        } catch (error) {
            return false;
        }
    };
    return {
        isIPhone14: isIphone14Device(),
        isIOS: device.isIOS(ua),
        isAndroid: device.isAndroid(ua),
        isLogin: device.isLogin(ua),
        isInApp: device.isInApp(),
        kpn: cookies.get('kpn'),
        ud: cookies.get('ud') || '',
        bucket: cookies.get('bucket') || '',
        webCountry,
    };
};

export const isProduction = process.env.NODE_ENV === 'production';

export const getCurrentOneLinkUrl = () => {
    if (isSnack) return 'https://snackvideoactivity.onelink.me/1i1L/client';
    if (isKwaiMe) return 'https://kwaime.onelink.me/V16i/client';
    return 'https://go.onelink.me/iGO2/client';
};

// ua字段
// kwai-me :  Kwai_Pro/ + version
// kwai-pro : Kwai_Pro/ + version
// kwai-snack : Kwai_Bulldog/ + version
